import { Injectable } from '@angular/core';
import { LoggingService } from '@src/app/services/logging/logging.service';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  constructor(
    private _loggingService: LoggingService,
  ) {
  }

  /**
   * Add analytics header if relevant cookie is set.
   *
   * @private
   */
  public addAnalytics(): void {
    this._loggingService.debug('Setting analytics permissions to true.');
    // TypeScript complains that the dataLayer does not exist; that is correct, as it is a field specifically used
    // and created by Google Tag Manager. As such, we expect this object to have been created (see index.html)
    // but will safeguard it for good measure anyway.
    // @ts-ignore
    window.dataLayer = window.dataLayer || [];
    // @ts-ignore
    window.dataLayer.push('consent', 'update', {
      ad_storage: 'granted',
      analytics_storage: 'granted',
    });
  }
}
